import { Button } from "@/components/ui/button";

export default function GoogleButton({ inviteCode = "", accountType = "", acceptedTerms = false, disabled = false, testid = "google-signin-btn" }) {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const params = new URLSearchParams();
    if (inviteCode.trim()) params.set("invite", inviteCode.trim().toUpperCase());
    if (accountType) params.set("type", accountType);
    if (acceptedTerms) params.set("terms", "1");
    const qs = params.toString();
    const redirectUrl = window.location.origin + "/app/chat" + (qs ? `?${qs}` : "");
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button data-testid={testid} type="button" variant="outline" onClick={go} disabled={disabled} className="w-full h-11 border-slate-300 bg-white hover:bg-slate-50 text-slate-800 font-medium">
      <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.2 1.3-1.6 3.9-5.5 3.9-3.3 0-6-2.7-6-6.1s2.7-6.1 6-6.1c1.9 0 3.1.8 3.9 1.5l2.6-2.6C16.8 3.1 14.6 2.1 12 2.1 6.5 2.1 2.1 6.6 2.1 12s4.4 9.9 9.9 9.9c5.7 0 9.5-4 9.5-9.7 0-.7-.1-1.2-.2-1.7H12z"/>
      </svg>
      Continue with Google
    </Button>
  );
}
